import { render, staticRenderFns } from "./list_of_products.vue?vue&type=template&id=8227d1e0&scoped=true&"
import script from "./list_of_products.vue?vue&type=script&lang=js&"
export * from "./list_of_products.vue?vue&type=script&lang=js&"
import style0 from "./list_of_products.vue?vue&type=style&index=0&id=8227d1e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8227d1e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VRating,VSkeletonLoader})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Intersect,Ripple})
